package com.jingfangpai.api.base

import com.jingfangpai.common.data.model.NetworkConfig
import kotlinx.browser.window

/**
 * 各平台在前端代码中自行提供配置
 */
actual fun getNetworkConfig(): NetworkConfig {
    val isHttps = "https:" == window.location.protocol
    var port = if(isHttps) 443 else 80
    if(!window.location.port.isNullOrBlank() && !isHttps){
        port = window.location.port.toInt()
    }
    return NetworkConfig(window.location.hostname,port,isHttps)
}
